import { atom } from 'jotai';
import { IUserDetail, IUserUnavailableDetail } from 'shared/models/user';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TUserDetailStore = { [key: string]: PromiseOrValue<IUserDetail | IUserUnavailableDetail> | undefined };

export const $UserDetailStore = atom<TUserDetailStore>({});

/**
 * get user detail data
 *
 * use user-unique-name as key
 */
export const $UserDetail = safeAtomFamily((userUniqueName: string) => {
  const a = atom<
    PromiseOrValue<IUserDetail | IUserUnavailableDetail>,
    [PromiseOrValue<IUserDetail | IUserUnavailableDetail>],
    void
  >(
    (get) => {
      const data = get($UserDetailStore)[userUniqueName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, userDetail) => {
      const old = get($UserDetailStore);
      set($UserDetailStore, { ...old, [userUniqueName]: userDetail });
    },
  );

  a.debugLabel = `$UserDetail+${encodeURIComponent(userUniqueName)}`;

  return a;
});
